import { defineComponent as E, ref as a, watch as k, useId as O, onMounted as _, onUnmounted as w, createElementBlock as C, openBlock as I, createElementVNode as g, withDirectives as b, renderSlot as h, normalizeClass as B, vShow as P, nextTick as S } from "vue";
import { createPopper as $ } from "@popperjs/core";
import { onClickOutside as H } from "@vueuse/core";
import { track as M } from "@ds/tracking/tracking";
const N = ["id"], x = ["id", "aria-describedby"], R = /* @__PURE__ */ E({
  name: "RevPopover",
  __name: "Popover",
  props: {
    contentClassNames: { default: "" },
    modifiers: { default: () => [] },
    position: { default: "top" },
    shouldHideOnClickOutside: { type: Boolean, default: !0 },
    shouldShowOnMount: { type: Boolean, default: !1 },
    triggerElementId: { default: void 0 }
  },
  setup(y) {
    const e = y, s = a(), r = a(), u = a(), t = a(!1), p = a(e.position), i = a(""), l = a("");
    let n = null;
    k(
      () => e.position,
      (o) => {
        n?.setOptions({ placement: o });
      }
    );
    const f = () => {
      M({
        action: "popover",
        context: {
          ...e,
          modifiers: e.modifiers,
          content: i.value,
          status: t.value ? "opened" : "closed",
          trigger: l.value
        }
      });
    };
    async function d() {
      if (!(t.value || !s.value || !u.value || !r.value)) {
        if (t.value = !0, await S(), n === null) {
          const o = (e.triggerElementId && document.getElementById(e.triggerElementId)) ?? u.value;
          if (!o)
            return;
          n = $(o, r.value, {
            modifiers: [
              ...e.modifiers,
              {
                name: "actualPosition",
                enabled: !0,
                phase: "main",
                fn: ({ state: v }) => {
                  p.value = v.placement;
                }
              }
            ],
            placement: e.position
          });
        } else
          n.forceUpdate();
        f();
      }
    }
    const c = () => {
      t.value = !1, f();
    };
    H(s, () => {
      e.shouldHideOnClickOutside && t.value && c();
    });
    const m = O();
    return _(async () => {
      i.value = `content-${m}`, l.value = `trigger-${m}`, e.shouldShowOnMount && (await document.fonts?.ready, d());
    }), w(() => {
      n !== null && (n.destroy(), n = null);
    }), (o, v) => (I(), C("span", {
      ref_key: "el",
      ref: s
    }, [
      g("span", {
        id: l.value,
        ref_key: "triggerEl",
        ref: u
      }, [
        h(o.$slots, "trigger", {
          ariaControls: i.value,
          ariaExpanded: t.value,
          ariaHaspopup: "true",
          hide: c,
          isOpen: t.value,
          show: d
        })
      ], 8, N),
      b(g("div", {
        id: i.value,
        ref_key: "contentEl",
        ref: r,
        "aria-describedby": l.value,
        class: B(o.contentClassNames)
      }, [
        h(o.$slots, "content", {
          hide: c,
          isOpen: t.value,
          position: p.value,
          show: d
        })
      ], 10, x), [
        [P, t.value]
      ])
    ], 512));
  }
});
export {
  R as default
};
